import styles from './api-error-message.module.scss';
import { Button } from '../button/button';

interface ErrorScreenProps {
	message: string,
  onSubmit?: () => void;
}

export default function ApiErrorMessage({ message, onSubmit }:ErrorScreenProps) {
	return (
    <div className={styles.default}>
      <div className={styles.container}>
        <h2 className={styles.title}>{message}</h2>
        <Button 
          onClick={() => onSubmit && onSubmit()} 
          type='button' 
          mode='apiError' 
          value="Попробовать снова"
        />
      </div>
    </div>
  )
}